import comp from "./AIChat";
export default comp;
